import { gql } from '@apollo/client';

export const REMOVE_CUSTODY_CHAIN_FROM_PROPERTY = gql`
mutation removeCustodyChainFromProperty($input: RemoveCustodyChainFromPropertyInput!) {
  removeCustodyChainFromProperty(input: $input) {
    __typename
    clientMutationId
    errors
    custodyChainUuid
  }
}
`
